import { render, staticRenderFns } from "./ObligationsTable.vue?vue&type=template&id=d97fd158&"
import script from "./ObligationsTable.vue?vue&type=script&lang=js&"
export * from "./ObligationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports